import React, { useCallback } from "react"
import PropTypes from "prop-types"

import { ProgressModal } from "@components/Page"

import useOrganizationsReport from "./helpers/useOrganizationsReport"
import OrganizationsDateRangeForm from "./OrganizationsDateRangeForm"

const LABEL_TITLE = "Organizations Report"


const OrganizationsReportModal = ({ modal }) => {
  const onReady = () => modal.current.close()

  const [ percent, start, stop, reset ] = useOrganizationsReport(onReady)

  const renderFilters = useCallback(() =>
    <OrganizationsDateRangeForm onSubmit={start} />
  , [ start ])

  const modalProps = {
    title: LABEL_TITLE,
    stop,
    reset,
    modal,
    start,
    percent,
    renderFilters,
  }

  return (
    <ProgressModal {...modalProps} />
  )
}

OrganizationsReportModal.propTypes = {
  modal: PropTypes.shape().isRequired
}

export default OrganizationsReportModal
